import { render, staticRenderFns } from "./TSiteVirtual.vue?vue&type=template&id=0d122c1a&"
import script from "./TSiteVirtual.vue?vue&type=script&lang=js&"
export * from "./TSiteVirtual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports